import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import PlatformsMarquee from '../components/PlatformsMarquee';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import Calculator from '../components/Calculator';
import ComparisonTable from '../components/ComparisonTable';
import Reviews from '../components/Reviews';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import ExitIntentModal from '../components/ExitIntentModal';
import SEO from '../seo/SEO';
import { localBusinessSchema, serviceSchema } from '../seo/schemas';

export default function Landing() {
  const location = useLocation();

  // Smoothly scroll to hash target whenever the URL hash changes (incl. on first
  // arrival from another route like /zones -> /#calculator).
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    // Wait one frame so the section is mounted, then scroll smoothly.
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
    return () => clearTimeout(t);
  }, [location.pathname, location.hash, location.key]);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <SEO
        title="3PL Fulfillment for Shopify & DTC Brands"
        description="Boutique 3PL fulfillment for Shopify and DTC brands. Same-day shipping from South Florida, $2 per order, no minimums, no contracts. Get a free instant savings estimate."
        keywords="3PL for Shopify, Shopify 3PL, DTC fulfillment, ecommerce fulfillment, Florida 3PL, no minimum 3PL, transparent 3PL pricing, same-day fulfillment, TikTok Shop fulfillment, Amazon FBM"
        schemas={[localBusinessSchema(), serviceSchema()]}
      />
      <Header />
      <main>
        <Hero />
        <PlatformsMarquee />
        <HowItWorks />
        <Pricing />
        <Calculator />
        <ComparisonTable />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <ExitIntentModal />
    </div>
  );
}
